import { createContext } from 'react';
export const PopoverContext = createContext({
    direction: 'down',
    contentTop: 0,
    contentBottom: 0,
    triggerLeft: 0,
    triggerRight: 0,
    offset: undefined,
    openPopover: false,
    setContentTop: () => { },
    setContentBottom: () => { },
    setTriggerLeft: () => { },
    setTriggerRight: () => { },
    setOpenPopover: () => { },
    setShowFade: () => { },
    showFade: false,
});
//# sourceMappingURL=PopoverContext.js.map